export const handleNavigate = ({
  record,
  isShowDriver = false,
  isShowPrice = false,
  isShowWhs = false,
  isShowLoaders = false,
  isShowManager = false,
  isShowSalesInfo = false,
  isShowSupplierInfo = false,
  isShowCustomerInfo = false,
  isShowInfoRequest = false,
  isShowWhsOnHand = false,
  isShowPrimichaniye = false,
  isPriceLower = false,
  title = "",
  isShowLoaderToResponsible = true,
}) => {
  console.log("record", record);
  sessionStorage.setItem(
    "orderData",
    JSON.stringify({
      data: record,
      isShowPrice: isShowPrice,
      isShowDriver: isShowDriver,
      isShowWhs: isShowWhs,
      isShowLoaders: isShowLoaders,
      isShowManager: isShowManager,
      isShowSalesInfo: isShowSalesInfo,
      isShowSupplierInfo: isShowSupplierInfo,
      isShowCustomerInfo: isShowCustomerInfo,
      isShowInfoRequest: isShowInfoRequest,
      isShowWhsOnHand: isShowWhsOnHand,
      isShowPrimichaniye: isShowPrimichaniye,
      isPriceLower: isPriceLower,
      title: title,
      isShowLoaderToResponsible: isShowLoaderToResponsible,
    }),
  );

  const url = `/orderPage`;
  window.open(url, "_blank");
};

export const loadersPdf = ({ data = [] }) => {
  handleNavigate({
    record: data,
    isShowDriver: false,
    isShowPrice: false,
    isShowWhs: false,
    isShowLoaders: true,
    isShowManager: true,
    isShowSupplierInfo: false,
    isShowCustomerInfo: true,
    isShowInfoRequest: false,
    isShowSalesInfo: true,
    isShowWhsOnHand: true,
    isShowPrimichaniye: false,
    isPriceLower: false,
    title: "Заказ",
  });
};
export const loadersPdfStockTransfers = ({ data = [] }) => {
  handleNavigate({
    record: data,
    isShowDriver: false,
    isShowPrice: false,
    isShowWhs: true,
    isShowLoaders: true,
    isShowManager: false,
    isShowSupplierInfo: false,
    isShowCustomerInfo: false,
    isShowInfoRequest: false,
    isShowSalesInfo: true,
    isShowWhsOnHand: true,
    isShowPrimichaniye: false,
    isPriceLower: false,
    title: "Перемешение",
  });
};
export const driverPdf = ({ data = [] }) => {
  handleNavigate({
    record: data,
    isShowDriver: true,
    isShowPrice: true,
    isShowWhs: false,
    isShowLoaders: true,
    isShowManager: true,
    isShowSupplierInfo: true,
    isShowCustomerInfo: true,
    isShowInfoRequest: false,
    isShowSalesInfo: true,
    isShowWhsOnHand: false,
    isShowPrimichaniye: true,
    isPriceLower: false,
    title: "Отгрузка",
  });
};
export const driverPdfExact = ({ data = [] }) => {
  handleNavigate({
    record: data,
    isShowDriver: true,
    isShowPrice: true,
    isShowWhs: false,
    isShowLoaders: true,
    isShowManager: true,
    isShowSupplierInfo: true,
    isShowCustomerInfo: true,
    isShowInfoRequest: false,
    isShowSalesInfo: true,
    isShowWhsOnHand: false,
    isShowPrimichaniye: true,
    isPriceLower: true,
    title: "Отгрузка",
  });
};
export const stockTransfersPdf = ({ data = [] }) => {
  handleNavigate({
    record: data,
    isShowDriver: true,
    isShowPrice: true,
    isShowWhs: true,
    isShowLoaders: true,
    isShowManager: false,
    isShowSupplierInfo: false,
    isShowCustomerInfo: false,
    isShowInfoRequest: true,
    isShowSalesInfo: false,
    isShowWhsOnHand: false,
    isShowPrimichaniye: false,
    isPriceLower: false,
    title: "Перемешение",
    isShowLoaderToResponsible: false,
  });
};
